const URL = {
  TOKEN_REROUTE: 'Auth/checkPoint',
  VALIDATE_TOKEN: 'Auth/validateToken',
  VALIDATE_SHORT_LINK: 'externalAuth/ValidateShortLink',
}
export default URL
